var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
/**
 * A component allows to add an event listener triggers on each click outside of the child element
 */
var ClickAwayListener = /** @class */ (function (_super) {
    __extends(ClickAwayListener, _super);
    function ClickAwayListener() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.clickAway = function (event) {
            var target = event.target;
            if (_this.el && target !== _this.el && !_this.el.contains(target)) {
                _this.props.clickAway(event);
            }
        };
        return _this;
    }
    ClickAwayListener.prototype.componentDidMount = function () {
        document.addEventListener('click', this.clickAway);
    };
    ClickAwayListener.prototype.componentWillUnmount = function () {
        document.removeEventListener('click', this.clickAway);
    };
    ClickAwayListener.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { ref: function (el) { _this.el = el || undefined; }, className: this.props.className || '' }, this.props.children));
    };
    return ClickAwayListener;
}(React.Component));
export default ClickAwayListener;
//# sourceMappingURL=ClickAwayListener.js.map